let _ = t => t,
  _t;
import styled from 'styled-components';
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTextSvg = styled.text.withConfig({
  displayName: "TextSvg__StyledTextSvg",
  componentId: "sc-2danc-0"
})(["alignment-baseline:middle;dominant-baseline:middle;text-transform:uppercase;user-select:none;"]);
const SVGWrapper = styledWithTheme.svg(_t || (_t = _`
  display: block;
  background-size: cover;
  background-position: center;
  text-anchor: middle;
  width: 100%;
  aspect-ratio: 1 / 1;
`));
export const TextSvg = ({
  children,
  fontSize
}) => /*#__PURE__*/_jsx(SVGWrapper, {
  viewBox: "0 0 100 100",
  xmlns: "http://www.w3.org/2000/svg",
  "data-svg-name": "text",
  children: /*#__PURE__*/_jsx(StyledTextSvg, {
    x: "50",
    y: "55",
    fontSize: fontSize,
    children: children
  })
});